import {BaseModuleProps} from "../../../../../infrastructure/models/props/base-module-props";
import {SideBarModuleController} from "../side-bar-module.controller";

export class SideBarModuleProps extends BaseModuleProps {
  controller: SideBarModuleController;
}
